module.exports = __webpack_public_path__ + "static/media/design-team.94a452ce.png";